import { render, staticRenderFns } from "./MemberGallery.vue?vue&type=template&id=2ea1fbd6"
import script from "./MemberGallery.vue?vue&type=script&lang=js"
export * from "./MemberGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports